import { useTranslation } from 'react-i18next';

export const keyPrefix = 'departmentPermissionTagList';
export const useDepartmentPermissionTagListTranslation = () => useTranslation('widgets', { keyPrefix });
export const ruRu = ({
  [keyPrefix]: {
    title: 'Теги доступа',
  },
}) as Record<string, unknown>;
export const en = ({
  [keyPrefix]: {
    title: 'Permission tags',
  },
}) as Record<string, unknown>;
export const esEs = ({
  [keyPrefix]: {
    title: 'Etiquetas de acceso',
  },
}) as Record<string, unknown>;
export const ptBr = ({
  [keyPrefix]: {
    title: 'Tags de acesso',
  },
}) as Record<string, unknown>;
